import { render, staticRenderFns } from "./EducationProgressReportForTeacher.vue?vue&type=template&id=4c855e04&"
import script from "./EducationProgressReportForTeacher.vue?vue&type=script&lang=js&"
export * from "./EducationProgressReportForTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports